import React, { VFC } from 'react';
import { Theme, useTheme } from '@material-ui/core/styles';
import styled from 'styled-components';
import LeftImage from '../../../../images/features/toyono/sub_title_left.png';
import RightImage from '../../../../images/features/toyono/sub_title_right.png';
import { TITLE_COLOR } from '~/src/feature/toyono/constants';

const Container = styled.div<{ theme: Theme }>`
  text-align: center;
  position: relative;
  display: inline-flex;
  flex-direction: column;
  margin: ${({ theme }) => theme.spacing(0, 0, 6)};
  width: 90%;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: auto;
  }
`;

const MainTitle = styled.div<{ theme: Theme }>`
  font-weight: bold;
  color: ${TITLE_COLOR};
  font-size: ${({ theme }) => theme.typography.pxToRem(20)};
  padding: ${({ theme }) => theme.spacing(1, 0, 0)};
  ${({ theme }) => theme.breakpoints.up('sm')} {
    font-size: ${({ theme }) => theme.typography.pxToRem(28)};
    padding: ${({ theme }) => theme.spacing(0, 6)};
  }
`;

const SubTitle = styled.div<{ theme: Theme }>`
  font-weight: bold;
  color: ${TITLE_COLOR};
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  font-family: 'Abel', sans-serif;
  letter-spacing: 1px;
`;

const OpenSquareBracket = styled.img<{ theme: Theme }>`
  position: absolute;
  left: 0;
  top: 0;
`;

const CloseSquareBracket = styled.img<{ theme: Theme }>`
  position: absolute;
  right: 0;
  top: 0;
`;

interface Props {
  text: string;
  children: string;
}

const Title: VFC<Props> = ({ text, children }: Props) => {
  const theme = useTheme();

  return (
    <Container theme={theme}>
      <MainTitle theme={theme}>{children}</MainTitle>
      <SubTitle theme={theme}>{text}</SubTitle>
      <OpenSquareBracket src={LeftImage} />
      <CloseSquareBracket src={RightImage} />
    </Container>
  );
};

export default Title;
